import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";

// Safe color helper with fallbacks
const safeAlpha = (color, alpha) => {
    try {
        if (!color) return `rgba(255, 255, 255, ${alpha})`;
        return Mixins.alpha(color, alpha);
    } catch (e) {
        console.warn('Color alpha error:', e, 'color:', color, 'alpha:', alpha);
        return `rgba(255, 255, 255, ${alpha})`;
    }
};

const safeDarken = (color, amount) => {
    try {
        if (!color) return '#cccccc';
        return Mixins.darken(color, amount);
    } catch (e) {
        console.warn('Color darken error:', e, 'color:', color);
        return '#cccccc';
    }
};

const useStyles = createUseStyles((isMobile: boolean) => ({
    dropdownContainer: ({ isMobile }) => ({
        position: "relative",
        width: "100%",
        maxWidth: isMobile ? "100%" : "220px",
    }),

    dropdownSelect: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0px 8px",
        maxWidth: isMobile ? "100%" : "300px",
        backgroundColor: ({ theme }) => safeAlpha(theme?.ControlBackground || '#ffffff', theme?.ControlAlpha || 1),
        border: ({ theme }) => `${theme?.BorderWidth || 1}px solid ${theme?.ControlBorderColor || '#cccccc'}`,
        borderRadius: ({ theme }) => theme?.BorderRadius || 4,
        cursor: "pointer",
        fontSize: "14px",
        fontFamily: ({ theme }) => `"${theme?.TextFont || 'Arial'}", sans-serif`,
        transition: "all 0.2s ease",
        outline: "none",
        minHeight: "27px",

        "&:hover": {
            borderColor: ({ theme }) => safeDarken(theme?.ControlBorderColor || '#cccccc', 0.2),
            backgroundColor: ({ theme }) => safeAlpha(theme?.ControlBackground || '#ffffff', Math.min((theme?.ControlAlpha || 1) + 0.1, 1)),
        },

        "&:focus": {
            borderColor: ({ theme }) => theme?.PrimaryColor || '#007bff',
        }
    },

    dropdownSelectHasValue: {
        color: ({ theme }) => theme?.TextColor || '#000000',
    },

    dropdownText: {
        flex: 1,
        textAlign: "left",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },

    dropdownIcon: {
        marginLeft: "8px",
        fontSize: "14px",
        color: ({ theme }) => safeAlpha(theme?.TextColor || '#000000', 0.6),
        transition: "transform 0.2s ease",
    },

    // Dropdown container styles
    dropdownList: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        position: "absolute",
        left: 0,
        right: 0,
        backgroundColor: ({ theme }) => theme?.Background || '#ffffff',
        border: ({ theme }) => `${theme?.BorderWidth || 1}px solid ${theme?.ControlBorderColor || '#cccccc'}`,
        borderRadius: ({ theme }) => theme?.BorderRadius || 4,
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)",
        zIndex: 1000,
        maxHeight: "300px",
        overflowY: "auto",
        padding: "8px",
    },

    dropdownListTop: {
        bottom: "100%",
        marginBottom: "4px",
    },

    dropdownListBottom: {
        top: "100%",
        marginTop: "4px",
    },

    choiceButton: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        padding: "4px",
        width: "max-content",
        borderRadius: "2px",
        backgroundColor: ({ theme }) => theme?.Background || '#ffffff',
        transition: "all 0.2s ease",
        "&:hover": {
            opacity: "0.9",
        },
    },

    choiceContent: {
        flex: 1,
        pointerEvents: 'none',
    },
    dropdownSelectError: {
        borderColor: "#F0345C !important",
        color: "#F0345C !important",
    },

}));

export default useStyles;
